/**
 * Read the order lookup credentials out of a location's query string.
 *
 * Two things this fixes over the previous inline version:
 *  - `encodeURI(searchParams.get('order'))` turned a missing param into the
 *    literal string "null", which then passed every `orderNumber ? ... : null`
 *    guard and was sent to the API as `order=null`.
 *  - the hash was concatenated onto the search string to cope with links that
 *    carry `?order=...#email=...`; that stays, but only when a hash is present.
 *
 * @param {{ search: string, hash?: string }} location
 * @returns {{ order: string|null, email: string|null, phone: string|null,
 *            bulk: string|null }}
 */
export const readOrderQuery = ({ search, hash = "" }) => {
  const params = new URLSearchParams(search + hash);

  return {
    order: params.get("order"),
    email: params.get("email"),
    phone: params.get("phone"),
    // Bulk order status links address the bulk order directly by id.
    bulk: params.get("bulk"),
  };
};

/** True when the query carries enough to attempt an order lookup. */
export const hasOrderCredentials = ({ order, email, phone }) =>
  Boolean(order) && Boolean(email || phone);
